import {
  BenefitHeroSlide,
  BenefitHeroSlideDto,
  BenefitHeroSlideModel,
} from 'src/models/BenefitHeroSlide/BenefitHeroSlide';
import { HttpService } from 'src/services';

abstract class BenefitHeroSlideService {
  static get = (): Promise<BenefitHeroSlide | null> =>
    HttpService
      .get<BenefitHeroSlideDto | null>('/public/benefit-hero-slides')
      .then((dto) => {
        if (!dto || !dto.id) return null;
        const hero = BenefitHeroSlideModel.fromDto(dto);
        const hasText = [hero.heading, hero.subheading, hero.copy]
          .some((text) => text.trim());
        return hasText ? hero : null;
      });
}

export default BenefitHeroSlideService;
